import moment from 'moment'

/*
Remove redundant components from the displayed range, e.g.
Aug 15—31, 2019
Aug 15—Oct 31, 2019
Aug 15, 2019—Oct 31, 2019
*/
const humanizeDateRange = (start, end, options = {}) => {
  const { year = true } = options
  // display empty string if no start or end date
  if (!start || !end) {
    return ''
  }

  const startDate = moment(start)
  const endDate = moment(end)
  const emdash = '—'

  if (startDate.year() === endDate.year()) {
    if (startDate.month() === endDate.month()) {
      return `${startDate.format('MMM D')}${emdash}${endDate.format(
        year ? 'D, YYYY' : 'D'
      )}`
    }
    return `${startDate.format('MMM D')}${emdash}${endDate.format(
      year ? 'MMM D, YYYY' : 'MMM D'
    )}`
  }
  return `${startDate.format('MMM D, YYYY')}${emdash}${endDate.format(
    year ? 'MMM D, YYYY' : 'MMM D'
  )}`
}

const formatDate = isoString => moment(isoString).format('M/D/YYYY')

export { humanizeDateRange, formatDate }
